import Icon from './Icon'

const GlobeIcon = (props) => (
  <Icon iconName="icon-globe" size={16} {...props}>
    <path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0ZM4.97 1.762C3.956 3.129 3.299 5.174 3.21 7.467H1.087A6.938 6.938 0 0 1 4.97 1.762ZM1.087 8.533H3.21c.089 2.293.746 4.338 1.76 5.705a6.935 6.935 0 0 1-3.883-5.705Zm6.38 6.326c-1.663-.465-3.051-3.057-3.189-6.326h3.189v6.326Zm0-7.392H4.278c.138-3.269 1.526-5.861 3.189-6.326v6.326Zm7.446 0H12.79c-.089-2.292-.745-4.337-1.76-5.705a6.938 6.938 0 0 1 3.883 5.705Zm-6.38-6.326c1.663.464 3.052 3.057 3.189 6.326H8.533V1.141Zm0 13.718V8.533h3.189c-.137 3.269-1.526 5.862-3.189 6.326Zm2.497-.621c1.015-1.368 1.671-3.413 1.76-5.705h2.123a6.937 6.937 0 0 1-3.883 5.705Z"></path>
  </Icon>
)

export default GlobeIcon
